const {LitElement, html, repeat, ref, nothing, createRef} = window.globalLit;

customElements.define('edit-step', class EditStepElement extends LitElement {
    static properties = {
        step: { type: Object },
        isOpen: { type: Boolean, state: true }
    };

    dialogRef = createRef();

    createRenderRoot() { return this; }

    constructor() {
        super();
    }

    open() {
        this.isOpen = true;
    }

    onHide() {
        this.isOpen = false;
    }
    
    _onChange(field, event) {
        this.step = Object.assign({}, this.step, {
            [field]: event.detail || event.target.value
        });

    }

    _onSaveClick() {
        this.dispatchEvent(new CustomEvent('stepchange', {
            detail: this.step,
            bubbles: true,
        }));

        this.isOpen = false;

        return false;
    }

    render() {

        if (!this.isOpen) {
            return nothing;
        }

        return html`
            <sl-dialog open label="Edit step" class="dialog-deny-close" @sl-hide=${this.onHide.bind(this)} id="editStepDialog">
                ${
                    this.step.element ? html`
                        <div class="mb-3">
                            <label>Element</label><br>
                            <element-selector 
                                .value=${this.step.element}
                                @selectorchange="${this._onChange.bind(this, 'element')}" >
                            </element-selector>
                        </div>
                    ` : nothing
                }

                <div class="mb-3">
                    <label>Enabled?</label><br>
                    <sl-checkbox .checked=${this.step.enabled} @sl-change=${this._onChange.bind(this, 'enabled')}></sl-checkbox>
                </div>


                <div class="p-3">
                    <div class="text-end">
                        <button type="button" name="action" value="continue" class="btn btn-primary btn-xs" @click=${this._onSaveClick.bind(this)}>
                            <i class="fa fa-save"></i>
                            Save &amp; close
                        </button>
                    </div>
                </div>
                

            </sl-dialog>
        `;
    }
});